<script setup lang="ts">
  interface IProps {
    type?: 'type1' | 'type2'
  }
  const props = withDefaults(defineProps<IProps>(), {
    type: 'type1',
  })
</script>

<template>
  <div class="marvel-legal-notice" :class="`marvel-legal-notice--${props.type}`">
    <div class="marvel-legal-notice__message">
      <span class="marvel-legal-notice__message-attention">Attention:</span> Purchasing
      <span class="marvel-legal-notice__message-bold"
        >virtual currency or a digital item only grants you a license</span
      >
      to use the currency or item within MapleStory. For the full license details, please see the
      <a href="https://www.nexon.com/main/en/legal/tou" target="_blank"
        >Terms of Service and End User License Agreement.</a
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
  // Used on Main Marvel Machine
  .marvel-legal-notice--type1 {
    .marvel-legal-notice__message {
      font-size: calc(14px * var(--marvel-desktopRatio));
      line-height: calc(17px * var(--marvel-desktopRatio));
      background: rgba(white, 0.7);
      border: 4px solid rgba(#dce0eb, 0.6);
      border-radius: calc(35px * var(--marvel-desktopRatio));
      padding: calc(17px * var(--marvel-desktopRatio));
    }
  }
  // Used on Buy Marvel
  .marvel-legal-notice--type2 {
    .marvel-legal-notice__message {
      font-size: 16px;
      line-height: 22px;
      background: #fef3d3;
      border: 4px solid rgba(#dce0eb, 0.8);
      border-radius: 20px;
      padding: 5px 10px;
    }
  }
  .marvel-legal-notice__message {
    color: #4d1b3e;

    text-align: center;
    a {
      color: #0476ff;
      text-decoration: underline;
    }
  }

  .marvel-legal-notice__message-attention {
    font-weight: bold;
  }

  .marvel-legal-notice__message-bold {
    color: #c94343;
  }

  @media #{$tabletForMarvel} {
  }
  @media #{$mobileForMarvel} {
    .marvel-legal-notice--type1 {
      .marvel-legal-notice__message {
        border: 4px solid rgba(#dce0eb, 0.6);
        background: rgba(white, 0.5);
      }
    }

    .marvel-legal-notice--type1,
    .marvel-legal-notice--type2 {
      .marvel-legal-notice__message {
        padding: 2vw;
        font-size: 2.2vw;
        line-height: 2.6vw;
      }
    }
  }
</style>
